import Vue from "vue";
const resolve = (path, obj) => {
  if (!path) return;
  return path.split(".").reduce(function(prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
};
Vue.directive("touch", {
  bind(el, bind, vnode) {
    el.addEventListener("input", () => {
      const obj = resolve(bind.expression, vnode.context.$v);
      if (obj) {
        obj.$touch();
      }
    });
    el.addEventListener(
      "blur",
      () => {
        const obj = resolve(bind.expression, vnode.context.$v);
        if (obj) {
          obj.$touch();
        }
      },
      true
    );
  }
});
